import { motion } from 'framer-motion';

export function AboutHero() {
  return (
    <section className="relative overflow-hidden py-24">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="container mx-auto px-4 text-center"
      >
        <h1 className="bg-gradient-to-r from-indigo-500 to-purple-500 bg-clip-text text-4xl font-bold text-transparent sm:text-5xl">
          Meet the Minds Behind StudySnap
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-lg text-gray-600">
          We're on a mission to revolutionize how students learn from video content
        </p>
      </motion.div>
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-indigo-50/50 via-white to-white"></div>
    </section>
  );
}